/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seat_Types_Admin_No_LightInputs */



/**
* | output |
* | --- |
* | "Admins can't have a Light seat." |
*
* @param {Seat_Types_Admin_No_LightInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_types_admin_no_light = /** @type {((inputs?: Seat_Types_Admin_No_LightInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Types_Admin_No_LightInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Administratoren können keinen Light-Platz haben.")
	return /** @type {LocalizedString} */ ("Admins can't have a Light seat.")
});